import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/phoneType";
export default class PhoneTypeService {
    static search(search, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            isSystem: search.isSystem,
            searchText: search.searchText,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
